import { render } from "./Mpw.vue?vue&type=template&id=8fd42654&scoped=true"
const script = {}

import "./Mpw.vue?vue&type=style&index=0&id=8fd42654&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8fd42654"

export default script